import { Molecule } from 'AppReact';
import styled from "styled-components";
import Title from './atoms/title';

const template = styled.div`
  font-size: 30px;
  display: flex;
  margin-right: 36px;
  cursor: pointer;
  color: ${({ displayState }) => displayState == 'selected' ? 'inherit' : 'grey'};
`;

export default Molecule({
    template,
    type: 'button',
    atoms: [
        {
            component: Title,
            name: 'Title',
            displayValue: ({ title }) => title
        }
    ]
})